<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10 tw-px-6 tw-text-center">
    <mdicon v-if="icon" :name="icon" size="48" class="tw-text-nc-medium tw-mb-3 tw-opacity-40" />
    <p v-if="title" class="tw-text-sm tw-font-semibold tw-text-nc-dark dark:tw-text-white tw-mb-1">{{ title }}</p>
    <p v-if="subtitle" class="tw-text-xs tw-text-nc-medium tw-max-w-xs">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'NcEmptyState',
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
};
</script>
